import {
  Box,
  Button,
  Icon,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { SignOut } from "@phosphor-icons/react";
import React, { useState } from "react";
import cr from "../lib/request";
import { useNavigate } from "react-router-dom";
import { Cookies } from "typescript-cookie";

type Props = {
  isOpenNav: boolean;
};

export default function SignoutModal({ isOpenNav }: Props) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [loading, setLoading] = useState<boolean>(false);
  const toast = useToast();
  const navigate = useNavigate();

  const onSignout = () => {
    setLoading(true);
    const url = `api/logout`;
    cr.post(url)
      .then((r) => {
        if (r.status === 200) {
          navigate("/");
          toast({
            title: "Berhasil Keluar",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          Cookies.remove("user");
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Box px={2}>
        <Button
          w={"100%"}
          leftIcon={<Icon as={SignOut} fontSize={24} mb={"2px"} />}
          pr={isOpenNav ? 4 : 1}
          className="btn-clear"
          color={"white"}
          onClick={onOpen}
        >
          <Text noOfLines={1}>{isOpenNav ? "Sign Out" : ""}</Text>
        </Button>
      </Box>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />

        <ModalContent>
          <ModalHeader>Signing Out</ModalHeader>
          <ModalBody>Apakah anda yakin untuk keluar?</ModalBody>
          <ModalFooter gap={2}>
            <Button className="btn" onClick={onSignout} isLoading={loading}>
              Sign Out
            </Button>
            <Button colorScheme="ap" onClick={onClose}>
              Ga jadi deh
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
